<template>
  <div class="filter-panel">
    <div class="search-content">
      <el-input v-model.trim="keyword" clearable :prefix-icon="Search" placeholder="请输入内容"></el-input>
    </div>

    <div class="industry-label">行业：</div>
    <div class="filter-content">
      <el-select v-model="trade" clearable placeholder="选中所属行业" :teleported="false">
        <el-option v-for="item in industryTabs" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </div>

    <div class="footer">
      <el-button @click="resetFn">重置</el-button>
      <el-button type="primary" class="apply-button" @click="sumbitFn">确定</el-button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, defineEmits } from 'vue';
import { Search } from '@element-plus/icons-vue'

const emits = defineEmits(['sumbitFn']);
const props = defineProps({
  industryTabs: {
    type: Array,
    default: () => ([])
  },

});

let keyword = ref('');
let trade = ref('');




let sumbitFn = () => {
  emits('sumbitFn', { keyword: keyword.value, trade: trade.value })
}
let resetFn = () => {
  keyword.value = ''
  trade.value = ''
}


</script>

<style lang="scss" scoped>
$template-background: #1c1c1c;
$template-text: #ffffff;
$button-bg: #6a0dad;
$button-hover-bg: #5a00b3;
$tab-bg: #2d2d3a;
$tab-selected-bg: #4c51bf;
$tab-hover-bg: #3c3c4e;
$edit-button-bg: #9f7aea;
$edit-button-hover-bg: #805ad5;
$star-button-bg: #ffeb3b;
$star-button-hover-bg: #d4af37;
$delete-button-bg: #e57373;
$delete-button-hover-bg: #d32f2f;

.filter-panel {
  padding: 10px;
  background-color: transparent;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  font-size: 14px;

  .industry-label {
    color: #ffffff;
    margin-bottom: 10px;
  }

  .search-content,
  .filter-content {
    margin-bottom: 20px;
  }

  .el-input,
  .el-select {
    width: 100%;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;


    .apply-button {
      color: $template-text;
      border: none;
      padding: 10px 20px;
      border-radius: 5px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: $button-hover-bg;
      }
    }
  }
}
</style>
